<template>
  <div class="categoryPage" v-if="isMobile">
        <div class="mainDropDown" v-if="this.$root.menu">
            <div class="imgToggleContianer" v-for="(item, index) in this.$root.menu" :key="index">
                <div class="imgToggle">
                        <div class="imageToglleMain" @click.prevent="mobileMenuToggle(item.id_category,item.name)" :class="{mainToggleActive:catIsActive && catIndex === item.id_category}">
                            <div class="imgOverLay">
                            <img class="mainBanner" v-if="item.mobile_image" :src="item.mobile_image"  />
                            <img  v-else class="mainBanner main-banner-Default" src="/img/DefaultCatImg.jpg" alt="">
                            <div class="menuToggleDiscription" >
                                    <span class="menuName"> {{ item.name }}  </span> 
                                    <!-- <span class="arrowToggle" > <span class=" toggleIcon"  ></span> </span> -->
                                    <span class="toggleIcon"></span>
                                    <p class="menuDiscription">{{ item.mobile_image_description }}</p>
                                
                            </div>
                            </div>
                        </div>
                        <ul  class="dropDownMenu" v-if="catIndex === item.id_category " :class="{activeDrp:catIsActive}">
                    
                            <div class="dropdownNavigation">
                               <router-link v-if="item.name === currentLinkName[currentLinkName.length -1]" :to="'/category/' + item.menu_url_key + '.html'"> 
                                    <button class="topMenuToggleLink"><span class="VisitLink">Visit All</span ><span style="margin-left:10px" class="mainVisitLink">{{item.name}} Stores</span></button>
                               </router-link>

                             <div class=""  v-if="item.childs">
                                <li v-for="(option, optionIndex) in item.childs" :key="optionIndex" class="dropdownNavigationList">
                                    <div class="dropDownHeading" @click.prevent="mobileSubMenuToggle(option.id_category,option.name)" >
                                        <p :class="{activeHeading:subCatIsActive && subCatIndex === option.id_category}">{{ option.name }}</p>
                                        <span class="childToggle toggleIcon" v-if="option.childs.length"  :class="{activeArr:subCatIsActive && subCatIndex === option.id_category}" ></span>
                                    </div>
                                    <ul v-if="subCatIndex === option.id_category" class="dropDownMenuLinks" :class="{activeDrp:subCatIsActive}">
                                         <router-link v-if="option.name === currentLinkName[currentLinkName.length -1]" :to="'/category/' + option.menu_url_key + '.html'"> 
                                            <button class="topMenuToggleLink"><span class="VisitLink">Visit All </span ><span style="margin-left:10px" class="mainVisitLink"> {{option.name}} Stores</span></button>
                                        </router-link>
                                        <div v-if="option.childs" >
                                            <li v-for="(itemLinks, LinkIndex) in option.childs" :key="LinkIndex" class="dropDownMenuLinksList">
                                            <router-link :to="'/category/' + itemLinks.menu_url_key + '.html'">{{ itemLinks.name }}</router-link>
                                        </li>
                                        </div>
                                    </ul>
                                </li>
                             </div>
                                    
                            </div>
                        </ul>
                </div>
            </div>
        </div>
       
    </div>
    
  <div class="noMenuFound" v-else>Something Went Wrong</div>

  <!-- <li v-for="(menu,index) in this.$root.menu" :key="index">{{menu.name}}</li>

</ul> -->
</template>

<script>
export default {
  name: "Categories",

  data: function () {
    return {
      menu: [],
      isMobile: false,
      catIndex:null,
      subCatIndex:null,
      catIsActive:false,
      subCatIsActive:false,
      currentLinkName:[],
    };
  },
  methods:{
      mobileMenuToggle(index,name) {
        if(!this.currentLinkName.includes(name)){
            this.currentLinkName.push(name)
        }else{
            this.currentLinkName.pop(name)
        }
       if(index != this.catIndex ){
            this.catIndex = index
            this.catIsActive = true
            return
            }
        this.catIndex = index
        this.catIsActive = !this.catIsActive
        this.subCatIndex = null;

    },
    mobileSubMenuToggle(index,name) {
        if(!this.currentLinkName.includes(name)){
                this.currentLinkName.push(name)
        }else{
            this.currentLinkName.pop(name)
        }
          if(index != this.subCatIndex){
                this.subCatIndex = index
                this.subCatIsActive = true
                return
            }
    
        this.subCatIsActive = !this.subCatIsActive
        this.subCatIndex = null;

    }

    },
  beforeMount() {
   
    if (window.innerWidth < 767) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  },
};

</script>

<style scoped>
 a {
     color: inherit;
     text-decoration: none;
 }
    
 .imageToglleMain {
     position: relative;
     width: 100%;
     min-height: 100px;
 }
  .imageToglleMain .mainBanner {
  width: 100%;
}
.menuToggleDiscription {
    position: absolute;
    top: 50%;
    transform: translate(0, -50%);
    left: 4%;
    width: 100%;
}
.menuToggleDiscription .menuName { 
    font-size: 14px;
    font-weight: 600;
    text-transform: uppercase;
    margin-right: 2%;
    color: #000000;
}

.menuToggleDiscription .menuDiscription { 
    font-size: 10px;
 }

 .toggleIcon {
    /* height: 51px; */
    /* padding: 16px 15px; */
    transition: all 0.3s ;
    display: inline-block;

 }
 .toggleIcon:before {
    content: "\f107";
    font: normal normal normal 14px/1 FontAwesome;
    font-size: 18px;
    transition: all 0.3s ;

}
.imageToglleMain.mainToggleActive .menuToggleDiscription span.toggleIcon , span.childToggle.activeArr  {
    transform: rotate(180deg) !important;
    /* content:"\f106"!important */

}
 .dropDownMenu , .dropDownMenuLinks {
    padding: 0;
    max-height: 0;
    /* height: auto; */
    opacity: 0;
    /* transition: height 10s ease; */
    background: #f5f5f5;
    transition: width 2s, height 4s;

}
.dropDownMenu li {
    list-style: none;

}

/* active classes */
.dropDownMenu.activeDrp {
    max-height: 1500px;
    opacity: 1;
    padding-bottom: 0;
}
.dropDownMenu.activeDrp  .dropDownHeading{ 
    padding:8px 12px;

}
.topMenuToggleLink {
    border: none;
    background: none;
    display: inline-block;
    padding: 0;
    padding-left: 12px;
    padding-top: 12px;
    font-size: 14px;
      text-transform: capitalize;
      font-weight: 600;

}

.dropDownMenuLinks.activeDrp{ 
    max-height: 1500px;
    opacity: 1;
    padding:0 ;
}

/* triangle icon */
 .imageToglleMain .imgOverLay::after {
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;
    background: rgba(255,255,255,0.3);
    top: 0%;
    /* z-index: 10000; */
    opacity: 0;
    left: 0%
}
.imageToglleMain:active .imgOverLay:after {
    opacity: 1;
} 
.imageToglleMain:after {
    content: '';
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 8px solid #fff;
    position: absolute;
    bottom: 0%;
    left: 6%;
    opacity: 0;
    transition: opacity 0.5s;
}
.imageToglleMain.mainToggleActive:after {
    opacity: 1;
}
/* first child dropdown  */
li.dropdownNavigationList {
    /* border-bottom: 1px solid #b9b2b2; */

}
.dropDownHeading {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 4px 4px
}


.topMenuToggleLink .mainVisitLink {
    color: #BA2126;
    font-weight: 600;
    
}
.dropDownHeading p{
    font-size: 14px; 
    text-transform: capitalize;
    margin: 0;
}
.dropDownHeading p.activeHeading {
    font-weight: 600;
    /* font-size: 16px; */
}
/* second child */
.dropDownMenuLinks {
    background: #fff;
}
.dropDownMenuLinks .topMenuToggleLink{
    border: none;
    background: none;
    display: inline-block;
    padding: 0;
    padding-left: 24px;
    padding-top: 14px;
    font-size: 12px;
    font-weight: 600;
    text-transform: capitalize;
}
li.dropDownMenuLinksList {
    font-size: 12px;
    padding: 8px 24px;
    /* border-top: 1px solid #b9b2b2; */
    /* background: #b9b2b2; */
}

img.mainBanner.main-banner-Default {
    margin-bottom: 1px;
}
</style>
